import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Dashboard = lazy(() => import('../pages/dashboard/page'));
const Login = lazy(() => import('../pages/auth/login'));
const BioLink = lazy(() => import('../pages/bio/page'));
const Redirect = lazy(() => import('../pages/redirect/page'));
const HowItWorks = lazy(() => import('../pages/how-it-works/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/dashboard',
    element: <Dashboard />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/how-it-works',
    element: <HowItWorks />,
  },
  {
    path: '/@:username',
    element: <BioLink />,
  },
  {
    path: '/s/:shortCode',
    element: <Redirect />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
